import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// --- ResizeObserver loop suppression (Radix + some scrollbars trigger this benign warning) ---
// The best fix is to defer the callback into the next animation frame so the loop error never fires.
if (typeof window !== "undefined" && window.ResizeObserver) {
  const OriginalRO = window.ResizeObserver;
  window.ResizeObserver = class DebouncedResizeObserver extends OriginalRO {
    constructor(cb) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          if (!Array.isArray(entries) || !entries.length) return;
          cb(entries, observer);
        });
      });
    }
  };
}
// Belt-and-braces: swallow any ResizeObserver messages still emitted so CRA's overlay stays quiet.
const _origError = window.console.error;
window.console.error = (...args) => {
  const msg = args?.[0]?.toString?.() || "";
  if (msg.includes("ResizeObserver loop")) return;
  _origError.apply(window.console, args);
};
window.addEventListener("error", (e) => {
  if (e?.message && e.message.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
window.addEventListener("unhandledrejection", (e) => {
  const msg = e?.reason?.message || "";
  if (msg.includes("ResizeObserver loop")) e.preventDefault();
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
